import React from "react";
import Logo from "@/components/Logo";

export default function Footer() {
    return (
        <footer className="mt-24 hairline-t bg-ivory" data-testid="site-footer">
            <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-14">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <Logo />
                        <p className="font-body text-sm ink-mute mt-5 leading-relaxed max-w-md">
                            A civilisational mission to document, preserve and live the soul of every Indian district.
                            Each portal speaks in the first person, because a district is not a place — it is a presence.
                        </p>
                    </div>
                    <div className="md:col-span-3">
                        <div className="font-data text-[10px] tracking-[0.2em] uppercase ink-mute mb-3">Modules</div>
                        <ul className="space-y-2 font-body text-sm">
                            <li><a href="/" data-testid="footer-link-portal" className="underline-reveal">District Portal</a></li>
                            <li><a href="/heritage-map" data-testid="footer-link-map" className="underline-reveal">Heritage Map</a></li>
                            <li><a href="/dashboard" data-testid="footer-link-dashboard" className="underline-reveal">Data Dashboard</a></li>
                        </ul>
                    </div>
                    <div className="md:col-span-4">
                        <div className="font-data text-[10px] tracking-[0.2em] uppercase ink-mute mb-3">Initiative</div>
                        <p className="font-body text-sm leading-relaxed">
                            Built on five pillars — the complete map, cultural narrative infrastructure,
                            digital-physical preservation, active dissemination, and civic identity.
                        </p>
                    </div>
                </div>
                <div className="editorial-rule my-10" />
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <div className="font-display text-base md:text-lg italic" data-testid="footer-brand">
                        Conlang International
                    </div>
                    <div className="font-data text-[10px] tracking-[0.22em] uppercase ink-mute">
                        Edition 01 · MMXXVI · A Living Biography of India
                    </div>
                </div>
            </div>
        </footer>
    );
}
